exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".merit-box-item[data-v-20449b40]{padding:80px 20px}.merit-item[data-v-20449b40]{text-align:center;transition:all .3s;-moz-transition:all .3s;-webkit-transition:all .3s;-o-transition:all .3s}.merit-item .merit-img[data-v-20449b40]{width:96px;height:90px;vertical-align:top}.merit-item .merit-name[data-v-20449b40]{margin-top:34px;color:#393939;font-size:18px;font-weight:700}.merit-item .merit-desc[data-v-20449b40]{margin-top:22px;color:#000;font-size:12px;line-height:22px}.merit-item[data-v-20449b40]:hover{transform:scale(1.2)}.merit-item:hover .merit-name[data-v-20449b40]{color:#f16622}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-20449b40","scoped":true,"hasInlineConfig":false}!./node_modules/postcss-loader/lib!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/index/merit.vue
// module id = 692
// module chunks = 0